"use client";

import * as React from 'react';
import { SpaceContext } from './context';
const Item = _ref => {
  let className = _ref.className,
    index = _ref.index,
    children = _ref.children,
    split = _ref.split,
    style = _ref.style;
  const _React$useContext = React.useContext(SpaceContext),
    latestIndex = _React$useContext.latestIndex;
  if (children === null || children === undefined) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: className,
    style: style
  }, children), index < latestIndex && split && /*#__PURE__*/React.createElement("span", {
    className: `${className}-split`
  }, split));
};
export default Item;